import moment, { Moment } from 'moment';
import {
  Allocation,
  AllocationForTeam,
  AllocationForUser,
} from 'api/resource-management/types';
import { AllocationEventModel } from 'components/organisms/resource-management/scheduler-config/models';
import {
  maximumDate,
  minimumDate,
} from 'components/organisms/resource-management/utils/common';
import { AllocationEvent } from '../../event-types';
import { Range } from '../../types';

export const getMinimumStartDate = <
  T extends
    | AllocationForUser
    | AllocationForTeam
    | AllocationEventModel
    | Allocation
    | AllocationEvent,
>(
  allocations: T[],
): Moment =>
  allocations.length > 0
    ? allocations.reduce(
        (minDate: Moment, { startDate }) =>
          moment(startDate).isBefore(minDate, 'day')
            ? moment(startDate).startOf('day')
            : minDate,
        maximumDate,
      )
    : minimumDate;
export const getMaximumEndDate = <
  T extends
    | AllocationForUser
    | AllocationForTeam
    | AllocationEventModel
    | Allocation
    | AllocationEvent,
>(
  allocations: T[],
): Moment =>
  allocations.length > 0
    ? allocations.reduce(
        (maxDate: Moment, { endDate }) =>
          moment(endDate).isAfter(maxDate, 'day')
            ? moment(endDate).endOf('day')
            : maxDate,
        minimumDate,
      )
    : maximumDate;

// TODO: May have to place this logic in appropriate folder
export const getMinimumStartDateFromListOfRanges = (ranges: Range[]): Moment =>
  ranges.reduce(
    (minDate: Moment, { fromDate }) =>
      moment(fromDate).isBefore(minDate, 'day')
        ? moment(fromDate).startOf('day')
        : minDate,
    maximumDate,
  );

export const getMaximumEndDateFromListOfRanges = (ranges: Range[]): Moment =>
  ranges.reduce(
    (maxDate: Moment, { toDate }) =>
      moment(toDate).isAfter(maxDate, 'day')
        ? moment(toDate).endOf('day')
        : maxDate,
    minimumDate,
  );
